module.exports = __webpack_public_path__ + "resource/img/banner_product.jpg?bcc3539f69f52e46ff55cc7f3c235885";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_product.jpg
// module id = 188
// module chunks = 36